<vw-page
  [page]="page"
  [alwaysFillNav]="true"
  *ngIf="page && category"
  [showDealerInformation]="true"
>
  <div class="category-page">
    <vw-page-header class="category-hero">
      <div breadcrumbs *ngIf="!!breadcrumbs.length">
        <vw-breadcrumbs [breadcrumbs]="breadcrumbs"></vw-breadcrumbs>
      </div>
      <div class="category-header" header>
        <div class="row">
          <div class="col-12">
            <h1 class="h2 category-hero-title">
              {{ category.displayName }}
            </h1>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <p class="mb-0 category-hero-subtitle">
              {{
                (channelRequestService.channelRequest &&
                channelRequestService.channelRequest.shoppingCart &&
                channelRequestService.channelRequest.shoppingCart.vehicle
                  ? "basedOnYourVehicle"
                  : "notBasedOnYourVehicle"
                ) | translate
              }}
            </p>

            <div class="d-md-flex">
              <p
                class="category-reg bold me-3"
                *ngIf="
                  channelRequestService.channelRequest &&
                  channelRequestService.channelRequest.shoppingCart &&
                  channelRequestService.channelRequest.shoppingCart.vehicle
                "
              >
                {{
                  channelRequestService.channelRequest.shoppingCart.vehicle
                    | vehicle
                }}
              </p>
              <p class="category-change-reg" (click)="openSelectDealerModal()">
                <u>{{ "changeRegNr" | translate }}</u>
              </p>
            </div>
          </div>
        </div>
      </div>
    </vw-page-header>

    <div class="heading-section">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-xl-10 mx-auto">
            <div class="d-md-flex align-items-center justify-content-between">
              <div>
                <span>
                  {{
                    (channelRequestService.channelRequest &&
                    channelRequestService.channelRequest.shoppingCart &&
                    channelRequestService.channelRequest.shoppingCart.vehicle
                      ? "categoryPage.basedOnYourVehicle"
                      : "categoryPage.notBasedOnYourVehicle"
                    ) | translate
                  }}
                </span>
                <span
                  class="d-block bold sum-title"
                  *ngIf="
                    (numberOfProductIDsReports === category.children?.length ||
                      !category.children?.length) &&
                    totalProductsSum > 0
                  "
                  >{{
                    "categoryPage.totalProductsSum"
                      | translate: { sum: totalProductsSum | number }
                  }}</span
                >
              </div>

              <div class="my-auto">
                <vw-sorting-select
                  (valueChanged$)="sortChanged($event)"
                ></vw-sorting-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <vw-popular-products
      [catalogCategory]="category"
      [productCarouselBackgroundColor]="false"
    ></vw-popular-products>
    <div class="products-section" *ngIf="!category.children?.length">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-xl-10 mx-auto">
            <h2 class="mb-4">
              {{
                "categoryPage.productsSectionTitle"
                  | translate: { categoryName: category.displayName }
              }}
            </h2>
            <vw-product-list
              [categoryId]="category.catalogCategoryId"
              (reportNumberOfProductIDs$)="reportNumberOfProductIDs($event)"
              [noProductsMessage]="'categoryPage.noProducts' | translate"
            >
            </vw-product-list>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="category.children && category.children.length">
      <div class="sub-category-section">
        <ng-container
          *ngFor="let subCategory of category.children; let i = index"
        >
          <ng-container
            *ngIf="
              subCategory.catalogCategoryId != null &&
              !hideCategories[subCategory.catalogCategoryId]
            "
          >
            <div class="sub-category">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 col-xl-10 mx-auto">
                    <div class="sub-category-title">
                      <vw-link
                        [routerLinks]="[
                          '/' + themeService.brand,
                          'category',
                          subCategory.catalogCategoryId,
                          subCategory.displayName || '' | encodeURIComponent,
                        ]"
                        [text]="subCategory.displayName"
                        [icon]="'fal fa-long-arrow-right'"
                        [anchorTagClass]="'h3'"
                      ></vw-link>
                    </div>

                    <vw-product-list
                      [categoryId]="subCategory.catalogCategoryId"
                      (reportNumberOfProductIDs$)="
                        reportNumberOfProductIDs($event)
                      "
                      [noProductsMessage]="
                        'categoryPage.noProducts' | translate
                      "
                    >
                    </vw-product-list>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </div>
</vw-page>
